<template>
  <el-dialog
    width="700px"
    :visible.sync="visibleProxy"
    :close-on-click-modal="false"
    title="设置单元格属性"
  >
    <label-configure
      title="题目设置"
      :display-text.sync="titleProxy"
      :same-biz-type="sameBizType"
      :direction.sync="title.direction"
      :type.sync="title.bizType"
      :biz-value.sync="title.values"
      :input-mode.sync="title.inputMode"
      :parent.sync="title.parentCell"
      :allow-parent="allowParent"
      :load-parent="loadTitleParentSource"
      :parent-value="titleParentValue"
    />
    <value-configure
      title="填写设置"
      :default-biz.sync="title.defaultBiz"
      :title-biz-type="title.bizType"
      :unique.sync="content.requiredUnique"
      :direction.sync="content.direction"
      :type.sync="content.bizType"
      :input-mode.sync="content.inputMode"
      :allowed-values.sync="content.allowedValues"
      :forbidden-values.sync="content.forbiddenValues"
      :custom-source.sync="content.customItems"
      :parent.sync="content.parentCell"
      :load-parent="loadAnswerParentSource"
    />
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="handleClose">取 消</el-button>
      <el-button size="mini" type="primary" @click="handleOk">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import {
  Button,
  Dialog,
  Divider,
  Input,
  MessageBox,
  Option,
  OptionGroup,
  Select,
  Switch,
} from "element-ui";
import ValueConfigure from "@/components/excel/designer/configure/value/value-configure";
import { CatalogChooser } from "@/components/excel/schema/label/catalog";
import { Direction as TitleDirection } from "@/components/excel/schema/label/direction";
import { Direction as ValueDirection } from "@/components/excel/schema/value/direction";
import {
  findModeChooser,
  findTypeText,
} from "@/components/excel/schema/label/type";
import TitleTypeSelector from "@/components/excel/designer/configure/label/TitleTypeSelector";
import LabelConfigure from "@/components/excel/designer/configure/label/label-configure";

export default {
  name: "designer-configure",
  components: {
    LabelConfigure,
    [TitleTypeSelector.name]: TitleTypeSelector,
    ValueConfigure,
    [Select.name]: Select,
    [OptionGroup.name]: OptionGroup,
    [Option.name]: Option,
    [Switch.name]: Switch,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Input.name]: Input,
    [Divider.name]: Divider,
  },
  props: {
    visible: {
      type: Boolean,
    },
    value: {
      type: Object,
    },
    loadTitleParentValue: Function,
    loadTitleParentSource: Function,
    loadAnswerParentSource: Function,
  },
  data() {
    const catalogs = CatalogChooser.options;
    const findDefaultType = (catalog) => {
      const catalogOption = CatalogChooser.options.find(
        (it) => it.value === catalog
      );
      if (!catalogOption) {
        return null;
      }
      if (!catalogOption.type) {
        return null;
      }
      return catalogOption.type.default;
    };
    const defaultCatalog = CatalogChooser.default;
    const defaultType = findDefaultType(defaultCatalog);
    const title = findTypeText(defaultType);
    const chooser = findModeChooser(defaultType);
    const defaultMode = chooser.default;
    return {
      content: {
        requiredUnique: false,
        bizCatalog: defaultCatalog,
        bizType: defaultType,
        inputMode: defaultMode,
        direction: ValueDirection.default,
        allowedValues: [],
        forbiddenValues: [],
        customItems: [],
        parentCell: null,
      },
      title: {
        direction: TitleDirection.default,
        bizCatalog: defaultCatalog,
        bizType: defaultType,
        inputMode: defaultMode,
        values: null,
        text: null,
        parentCell: null,
        defaultBiz: true,
      },
      defaultTypeTitle: title,
      selectTypeTitle: null,
      catalogs,
      titleParentValue: null,
    };
  },
  watch: {
    "title.defaultBiz": {
      handler(value) {},
    },
    "title.bizType": {
      handler(type, oldType) {
        // if (type === oldType && this.title.defaultBiz) {
        //   this.defaultTypeTitle = findTypeText(type);
        // }
        if (this.content.bizType === type || this.title.defaultBiz) {
          const { text } = this.$props.value.title;
          if (!text || findTypeText(oldType) === text)
            this.updateTitleText(findTypeText(type));
        }
      },
    },
    "content.bizType": {
      handler(type, oldType) {
        console.log("标题类型变了", type, oldType);
        if (this.title.bizType === type || this.title.defaultBiz) {
          const { text } = this.$props.value.title;
          if (!text || findTypeText(this.title.bizType) === text)
            this.updateTitleText(findTypeText(type));
        }
        // if (type !== oldType && !this.title.defaultBiz) {
        //   // this.defaultTypeTitle = findTypeText(type);
        //   console.log("我要改变标题的值");
        //   this.title.values = null;
        // }
      },
    },
    "title.parentCell": {
      handler(value) {
        const { loadTitleParentValue } = this.$props;
        if (!loadTitleParentValue) {
          return;
        }
        if (value) {
          this.titleParentValue = this.$props.loadTitleParentValue(value);
        } else {
          this.titleParentValue = null;
        }
      },
    },
    value: {
      deep: true,
      handler(value) {
        console.log(value);
        const { title, content } = value;
        this.updateTitle(title);
        this.updateContent(content);
      },
    },
  },
  computed: {
    visibleProxy: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
    titleProxy: {
      get() {
        if (this.title.defaultBiz) {
          return this.defaultTypeTitle;
        }
        return this.selectTypeTitle;
      },
      set(value) {
        // this.updateTitleText(value);
      },
    },
    allowParent() {
      const { title, content } = this;
      return this.title.defaultBiz || title.bizType === content.bizType;
    },
    sameBizType() {
      const { title, content } = this;
      return title.defaultBiz || title.bizType === content.bizType;
    },
  },
  methods: {
    handleClose(done) {
      if (!this.$props.visible) {
        // 点确定之后 关闭 改变了visible 也会触发这个事件
        return;
      }
      MessageBox.confirm("确认关闭？")
        .then((_) => {
          this.$emit("update:visible", false);
          done();
        })
        .catch((_) => {});
    },
    handleOk() {
      this.$emit("update:visible", false);
      const content = this.content;
      const text = this.title.text;
      // const text = this.titleProxy;
      // const text =
      //   this.$props.value.title.text ||
      //   (this.sameBizType ? this.defaultTypeTitle : "");
      const title = { ...this.title, text };
      if (title.defaultBiz) {
        content.bizType = title.bizType;
      }
      const payload = {
        content,
        title,
      };
      this.$emit("ok", payload);
    },
    emitChangeType(type) {
      this.$emit("update:type", type);
      this.$emit("change-type", type);
    },
    updateTitleText(value) {
      // if (this.title.defaultBiz) {
      //   this.defaultTypeTitle = value;
      // } else {
      //   this.selectTypeTitle = value;
      // }
      console.log("马上更新标题文本", value)
      this.title.text = value;
    },
    updateDirection(direction) {
      this.content.direction = direction;
    },
    updateContent(content) {
      const { requiredUnique, bizCatalog, parentCell } = content;
      const { bizType, inputMode, allowedValues } = content;
      const { forbiddenValues, customItems, direction } = content;
      this.content.requiredUnique = requiredUnique;
      this.content.bizCatalog = bizCatalog;
      this.content.bizType = bizType;
      this.content.inputMode = inputMode;
      this.content.direction = direction;
      this.content.allowedValues = allowedValues;
      this.content.forbiddenValues = forbiddenValues;
      this.content.customItems = customItems;
      this.content.parentCell = parentCell;
    },
    updateTitle(title) {
      const { defaultBiz, bizCatalog, bizType, direction } = title;
      const { inputMode, text, values, parentCell } = title;
      this.title.defaultBiz = defaultBiz;
      this.title.bizCatalog = bizCatalog;
      this.title.bizType = bizType;
      this.title.inputMode = inputMode;
      this.title.values = values;
      this.title.parentCell = parentCell;
      this.updateDirection(direction);
      this.updateTitleText(text);
    },
  },
  mounted() {
    const { title, content } = this.$props.value;
    this.updateTitle(title);
    this.updateContent(content);
  },
};
</script>
<style scoped>
div >>> .el-dialog > .el-dialog__body {
  padding: 0 20px;
}
div >>> .template-label {
  width: 100px;
  display: inline-block;
}
div >>> .template-item-wrapper {
  padding: 5px 0;
}
</style>
